import axios from 'axios';
import Bluebird from 'bluebird';
import _ from 'lodash';

// Add a response interceptor to handle session timeouts/user not being logged in
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.data && error.response.data._statusCode === 401 && error.response.data._isLoginRequired) {
        return window.location.reload();
    }
    return Bluebird.reject(error);
});
